import { Subject } from 'rxjs';
import { BaseProvider } from 'src/app/core/services/base-provider';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/services/globals.service";
import * as i2 from "@angular/common/http";
import * as i3 from "../../../core/services/ls-helper.service";
import * as i4 from "../../../core/services/auth.service";
import * as i5 from "../../../core/services/utils.service";
export class TransactionService extends BaseProvider {
    constructor(globals, http, ls, authService, utilsService) {
        super();
        this.globals = globals;
        this.http = http;
        this.ls = ls;
        this.authService = authService;
        this.utilsService = utilsService;
        this.itemToEdit = { Id: null };
        this.transactionId = 'new';
        this.visibleModule = 'main';
        this.timeline = [];
        this.isReturning = false;
        this.stopCamera = false;
        this.searchList = [];
        this.transactionRefresher = new Subject();
        this.afterTransactionRefresh = new Subject();
        this.filter = '';
        this.copyAmount = 1;
        this.proponent = {};
        this.baseUrl = 'userProcess';
    }
    clearTransactionRefresher() {
        this.transactionRefresher.unsubscribe();
        this.transactionRefresher = new Subject();
    }
    getLookups() {
        return new Promise((resolve, reject) => {
            if (this.lookups) {
                resolve(this.lookups);
            }
            this.url = this.globals.dataUrl + this.baseUrl + '/lookup';
            this.http.get(this.url).subscribe((data) => {
                this.lookups = data.Data;
                resolve(data.Data);
            }, (err) => {
                reject(err);
            });
        });
    }
    getById(id) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/' + id;
            this.http.get(this.url).subscribe((data) => {
                this.itemToEdit = data.Data;
                if (!this.itemToEdit.CaseNumber && !this.itemToEdit.CadastreNumber) {
                    this.itemToEdit.CadastreNumber = this.itemToEdit.TempCaseNumber;
                }
                if (this.itemToEdit.CaseNumber && !this.itemToEdit.CadastreNumber) {
                    this.itemToEdit.CadastreNumber = this.itemToEdit.CaseNumber;
                }
                resolve(data.Data);
            }, (err) => {
                reject(err);
            });
        });
    }
    getTimeline(id) {
        return new Promise((resolve, reject) => {
            this.url =
                this.globals.dataUrl + this.baseUrl + '/process/' + id + '/timeline';
            this.http.get(this.url).subscribe((data) => {
                this.timeline = data.Data;
                resolve(data.Data);
            }, (err) => {
                reject(err);
            });
        });
    }
    getTransactionsForUser() {
        return new Promise((resolve, reject) => {
            this.url =
                this.globals.dataUrl +
                    this.baseUrl +
                    '/page/' +
                    this.page +
                    '/size/' +
                    this.size;
            this.http.get(this.url).subscribe((data) => {
                this.list = data.Data;
                resolve(data.Data);
            }, (err) => {
                reject(err);
            });
        });
    }
    getFilteredTransactionsForUser() {
        return new Promise((resolve, reject) => {
            this.url =
                this.globals.dataUrl +
                    this.baseUrl +
                    '/page/' +
                    this.page +
                    '/size/' +
                    this.size +
                    '/filter/' +
                    this.filter;
            this.http.get(this.url).subscribe((data) => {
                this.list = data.Data;
                resolve(data.Data);
            }, (err) => {
                reject(err);
            });
        });
    }
    getStats() {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/stats';
            this.http.get(this.url).subscribe((data) => {
                this.stats = data.Data;
                resolve(data.Data);
            }, (err) => {
                reject(err);
            });
        });
    }
    getProponentById(userId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + 'userProfile/' + userId;
            this.http.get(this.url).subscribe((data) => {
                this.proponent = data.Data;
                resolve(data.Data);
            }, (err) => {
                reject(err);
            });
        });
    }
    getCounter(id) {
        return new Promise((resolve, reject) => {
            this.url =
                this.globals.dataUrl +
                    this.baseUrl +
                    '/counter/processId/' +
                    id +
                    '/copies/' +
                    this.copyAmount;
            this.http.get(this.url).subscribe((data) => {
                this.counter = data.Data;
                resolve(data.Data);
            }, (err) => {
                reject(err);
            });
        });
    }
    searchTransactions(params) {
        this.list = [];
        return new Promise((resolve, reject) => {
            let statusId;
            statusId = params.statusId;
            if (params.statusId.label) {
                statusId = params.statusId.label;
            }
            this.url =
                this.globals.dataUrl +
                    this.baseUrl +
                    '/proponente/search/page/' +
                    params.pageNumber +
                    '/size/' +
                    params.pageSize +
                    '?term=' +
                    params.term +
                    this.utilsService.formatParamUri({
                        paramField: statusId,
                        paramName: 'status',
                    }) +
                    this.utilsService.formatParamUri({
                        paramField: params.dateFrom,
                        paramName: 'dateFrom',
                    }) +
                    this.utilsService.formatParamUri({
                        paramField: params.dateTo,
                        paramName: 'dateTo',
                    }) +
                    this.utilsService.formatParamUri({
                        paramField: params.processType,
                        paramName: 'processType',
                    }) +
                    this.utilsService.formatParamUri({
                        paramField: params.filterByFlagged,
                        paramName: 'filterByFlagged',
                    }) +
                    this.utilsService.formatParamUri({
                        paramField: params.sortColumn,
                        paramName: 'sortColumn',
                    }) +
                    this.utilsService.formatParamUri({
                        paramField: params.sortDirection,
                        paramName: 'sortDirection',
                    });
            this.http.get(this.url).subscribe((data) => {
                this.list = data.Data;
                // this.pageData(data.Data);
                resolve(data.Data);
            }, (err) => {
                reject(err);
            });
        });
    }
    searchTransactionsAdvancedSearch(params) {
        return new Promise((resolve, reject) => {
            this.url =
                this.globals.dataUrl +
                    'capitalCase/search/advanced' +
                    '/page/' +
                    params.pageNumber +
                    '/size/' +
                    params.pageSize +
                    '?clientName=' +
                    params.clientName +
                    '&caseNumber=' +
                    params.caseNumber +
                    '&finca=' +
                    params.finca +
                    '&loanNumber=' +
                    params.loanNumber;
            this.http.get(this.url).subscribe((data) => {
                this.list = data.Data;
                resolve(data.Data);
            }, (err) => {
                reject(err);
            });
        });
    }
    startTransaction(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl;
            this.http.post(this.url, params).subscribe((data) => {
                resolve(data);
            }, (err) => {
                reject(err);
            });
        });
    }
    startUserProcessCreateWithParent(params) {
        return new Promise((resolve, reject) => {
            this.url = `${this.globals.dataUrl}${this.baseUrl}/userProcessCreateWithParent`;
            this.http.post(this.url, params).subscribe((data) => {
                resolve(data);
            }, (err) => {
                reject(err);
            });
        });
    }
    startUserProcessCreateRenovation(params) {
        return new Promise((resolve, reject) => {
            this.url = `${this.globals.dataUrl}${this.baseUrl}/userProcessCreateRenovation`;
            this.http.post(this.url, params).subscribe((data) => {
                resolve(data);
            }, (err) => {
                reject(err);
            });
        });
    }
    attendTransaction(processId) {
        return new Promise((resolve, reject) => {
            this.url =
                this.globals.dataUrl + this.baseUrl + `/process/${processId}/attend`;
            this.http.post(this.url, null).subscribe((data) => {
                resolve(data);
            }, (err) => {
                reject(err);
            });
        });
    }
    submitTransaction(processId) {
        return new Promise((resolve, reject) => {
            this.url =
                this.globals.dataUrl + this.baseUrl + `/process/${processId}/submit`;
            this.http.post(this.url, null).subscribe((data) => {
                resolve(data);
            }, (err) => {
                reject(err);
            });
        });
    }
    userCanAttendCase() {
        let canAttend = false;
        if (this.itemToEdit.CurrentUserCanAttendCase === 1 &&
            this.itemToEdit.AssignedToCurrentUser !== 1) {
            canAttend = true;
        }
        return canAttend;
    }
    userCanInteract() {
        let canInteract = false;
        const canAttendProcesses = this.authService.hasPolicyBool('CanAttendProcesses');
        if (this.itemToEdit.AssignedToCurrentUser === 1 ||
            this.itemToEdit.CreatedByCurrentUser === 1 ||
            canAttendProcesses) {
            canInteract = true;
        }
        return canInteract;
    }
    deleteTransaction(transactionId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + `/${transactionId}`;
            this.http.delete(this.url).subscribe((data) => {
                resolve(data);
            }, (err) => {
                reject(err);
            });
        });
    }
    userCreatedCase() {
        let createdCase = false;
        if (this.itemToEdit.CreatedByCurrentUser === 1) {
            createdCase = true;
        }
        return createdCase;
    }
    getTransactionsByParams(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + 'adminUserTransaction' + '/search';
            this.http.get(this.url, { params }).subscribe((data) => {
                this.searchList = data.Data;
                resolve(data.Data);
            }, (err) => {
                reject(err);
            });
        });
    }
    getTransactionsByProfileId(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + 'adminUserTransaction' + '/searchByUserProfile';
            this.http.get(this.url, { params }).subscribe((data) => {
                this.searchList = data.Data;
                resolve(data.Data);
            }, (err) => {
                reject(err);
            });
        });
    }
    UserProcessProfileUpdate(profileId, processTypeIds) {
        return new Promise((resolve, reject) => {
            this.url = `${this.globals.dataUrl}${'adminUserTransaction'}/userProcessId/profileId/${profileId}`;
            this.http.post(this.url, { processTypeIds: processTypeIds, profileId: profileId }).subscribe((data) => {
                resolve(data);
            }, (err) => {
                reject(err);
            });
        });
    }
    OtherUserProcessProfileUpdate(profileId, otherUserId, processTypeIds) {
        return new Promise((resolve, reject) => {
            this.url = `${this.globals.dataUrl}${'adminUserTransaction'}/otherUser/${otherUserId}/userProcessId/profileId/${profileId}`;
            this.http.post(this.url, { processTypeIds: processTypeIds, profileId: profileId, otherUserId: otherUserId }).subscribe((data) => {
                resolve(data);
            }, (err) => {
                reject(err);
            });
        });
    }
    delete(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + 'adminUserTransaction' + '/' + params.id;
            this.http.delete(this.url).subscribe((data) => {
                resolve(data);
            }, (err) => {
                reject(err);
            });
        });
    }
    searchTransactionsByProfile(params) {
        this.list = [];
        return new Promise((resolve, reject) => {
            let statusId;
            statusId = params.statusId;
            if (params.statusId.label) {
                statusId = params.statusId.label;
            }
            const selectedProfile = JSON.parse(localStorage.getItem('selectedProfile'));
            if (selectedProfile) {
                this.url =
                    `${this.globals.dataUrl}${this.baseUrl}ByProfile/${selectedProfile.Id}/search?pageNumber=${params.pageNumber}&pageSize=${params.pageSize}` +
                        this.utilsService.formatParamUri({
                            paramField: params.term === 'null' ? '' : params.term,
                            paramName: 'term',
                        }) +
                        this.utilsService.formatParamUri({
                            paramField: statusId,
                            paramName: 'status',
                        }) +
                        this.utilsService.formatParamUri({
                            paramField: params.dateFrom,
                            paramName: 'dateFrom',
                        }) +
                        this.utilsService.formatParamUri({
                            paramField: params.dateTo,
                            paramName: 'dateTo',
                        }) +
                        this.utilsService.formatParamUri({
                            paramField: params.processType,
                            paramName: 'processType',
                        }) +
                        this.utilsService.formatParamUri({
                            paramField: params.filterByFlagged,
                            paramName: 'filterByFlagged',
                        }) +
                        this.utilsService.formatParamUri({
                            paramField: params.sortColumn,
                            paramName: 'sortColumn',
                        }) +
                        this.utilsService.formatParamUri({
                            paramField: params.sortDirection,
                            paramName: 'sortDirection',
                        });
            }
            else {
                this.list = [];
                resolve([]);
                return;
            }
            this.http.get(this.url).subscribe((data) => {
                this.list = data.Data;
                // this.pageData(data.Data);
                resolve(data.Data);
            }, (err) => {
                reject(err);
            });
        });
    }
}
TransactionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TransactionService_Factory() { return new TransactionService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.LsHelperService), i0.ɵɵinject(i4.AuthService), i0.ɵɵinject(i5.UtilsService)); }, token: TransactionService, providedIn: "root" });
